import memoize from 'lodash/fp/memoize'
import { ICountry, SupportedCountryCode } from '@cbgms/api'
import { allowedFlags } from './types'
import { CountriesReducerState } from './reducers'
import { CountryDropdownItem } from '@carsys/form/src/CountriesDropdownBase'

const isoCodeToFlag = (isoCode: string) => {
  const code = isoCode.toLowerCase()
  if (allowedFlags.indexOf(code) > -1) {
    return code
  }

  return null
}

export const getCountriesAsDropdownOptions = memoize((countriesState: CountriesReducerState): CountryDropdownItem[] => {
  return mapAllCountryToDropdownOptions(countriesState.all.countries)
})

export const getEnvironmentCountriesAsDropdownOptions = memoize((countriesState: CountriesReducerState): CountryDropdownItem[] => {
  return mapSupportedCountryToDropdownOptions(countriesState.environment)
})

export const getSupportedCountriesAsDropdownOptions = memoize((countriesState: CountriesReducerState): CountryDropdownItem[] => {
  return mapSupportedCountryToDropdownOptions(countriesState.supported)
})

export const mapAllCountryToDropdownOptions = (countries: readonly ICountry[]) => {
  return countries.map(country => ({
    key: country.IsoCode,
    value: country.IsoCode,
    flag: isoCodeToFlag(country.IsoCode),
    text: country.Name
  }))
}

export const mapSupportedCountryToDropdownOptions = (countries: readonly SupportedCountryCode[]) => {
  return countries.map(country => ({
    key: country.Code,
    value: country.Code,
    flag: isoCodeToFlag(country.Code),
    text: country.FullName
  }))
}

export const mapAllCountries = (countries: ICountry[]): SupportedCountryCode[] =>
  countries.map(country => ({
    Code: country.IsoCode,
    FullName: country.Name,
    RegistrationCode: country.IsoCode,
    Imperial: country.Imperial
  }))
